import {
  isArray,
  isObject,
  isString
} from "./chunk-I7UKD6FS.mjs";

// src/utils.ts
import { klona } from "klona/full";
function structuredClone(v) {
  return klona(v);
}
function toEvent(event) {
  const obj = isString(event) ? { type: event } : event;
  return obj;
}
function toArray(value) {
  if (!value)
    return [];
  return isArray(value) ? value.slice() : [value];
}
function isGuardHelper(value) {
  return isObject(value) && value.predicate != null;
}

export {
  structuredClone,
  toEvent,
  toArray,
  isGuardHelper
};
